export function exec(doc, cmd, val = null) {
  if (!doc) return;
  doc.body.focus();
  doc.execCommand(cmd, false, val);
}

export function formatBlock(doc, tag) {
  exec(doc, "formatBlock", tag);
}

export function applyFontSize(doc, px) {
  const sel = doc.getSelection();
  if (!sel || sel.rangeCount === 0) return;
  const range = sel.getRangeAt(0);
  if (range.collapsed) return;
  const span = doc.createElement("span");
  span.style.fontSize = `${px}px`;
  try { range.surroundContents(span); }
  catch {
    const frag = range.extractContents();
    span.appendChild(frag);
    range.insertNode(span);
  }
  sel.removeAllRanges();
  const r = doc.createRange();
  r.selectNodeContents(span);
  sel.addRange(r);
}

export function applyLineHeight(doc, value) {
  const sel = doc.getSelection();
  if (!sel || sel.rangeCount === 0) return;
  let node = sel.anchorNode;
  if (node?.nodeType === 3) node = node.parentElement;
  const block = node?.closest?.("p,h1,h2,h3,h4,h5,h6,li,blockquote,div");
  if (block) block.style.lineHeight = value;
}

export function toggleInlineCode(doc) {
  const sel = doc.getSelection();
  if (!sel || sel.rangeCount === 0) return;
  const range = sel.getRangeAt(0);
  let node = sel.anchorNode;
  if (node?.nodeType === 3) node = node.parentElement;
  const existing = node?.closest?.("code");
  if (existing) {
    const parent = existing.parentNode;
    while (existing.firstChild) parent.insertBefore(existing.firstChild, existing);
    parent.removeChild(existing);
    return;
  }
  if (range.collapsed) return;
  const code = doc.createElement("code");
  try { range.surroundContents(code); }
  catch {
    const frag = range.extractContents();
    code.appendChild(frag);
    range.insertNode(code);
  }
}

export function insertDivider(doc) {
  exec(doc, "insertHorizontalRule");
}

export function clearFormatting(doc) {
  exec(doc, "removeFormat");
  const sel = doc.getSelection();
  if (!sel || sel.rangeCount === 0) return;
  let node = sel.anchorNode;
  if (node?.nodeType === 3) node = node.parentElement;
  const block = node?.closest?.("p,h1,h2,h3,h4,h5,h6,li,blockquote,div,body");
  if (!block) return;
  block.querySelectorAll("span[style]").forEach((s) => {
    const parent = s.parentNode;
    while (s.firstChild) parent.insertBefore(s.firstChild, s);
    parent.removeChild(s);
  });
}

export function applyForeColor(doc, color) {
  exec(doc, "foreColor", color);
}

export function applyBackColor(doc, color) {
  exec(doc, "hiliteColor", color);
  exec(doc, "backColor", color);
}
